module.exports = __webpack_public_path__ + "img/activity-title-mobile.d171dad1.png";